export default __webpack_public_path__ + "static/media/gallery-wip-before-paint_00.bfb8aaef.jpg";